/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Add } from "@mui/icons-material";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import {
  getDescuentosCristal,
  getDescuentoCristal,
} from "../../../project/services/DescuentoCristalService";
import { getCacheData } from "../../services/CacheService";
import DescuentoCristalProductoDialog from "./DescuentoCristalDialog";
import Message from "../../../project/utils/Message";
import { parse } from 'date-fns';
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  idCristalProducto: "",
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const nameItemsText = "Descuentos de cristales";
//
// #############################################################################
//
const DescuentoCristalProductoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [valueACCristalProducto, setValueACCristalProducto] = useState({
    id: "",
    label: "",
  });
  const [inputValueACCristalProducto, setInputValueACCristalProducto] =
    useState("");
  const [cristalProductos, setCristalProductos] = useState([]);

  const { hasPermission } = useContext(AuthContext);
  const _crearDescuento = hasPermission("descuento-c");
  const _editarDescuento = hasPermission("descuento-e");
  const _habilitarDescuento = hasPermission("descuento-h");
  const _deshabilitarDescuento = hasPermission("descuento-d");

  const tableColumns = [
    {
      field: "descripcion_cristal_producto",
      headerName: "Producto",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_cristal_producto;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "porcentaje_descuento",
      headerName: "% Desc.",
      headerAlign: "center",
      align: "right",
      flex: 0.5,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.porcentaje_descuento;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "fecha_vigencia_desde",
      headerName: "Vigencia desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_vigencia_desde;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "fecha_vigencia_hasta",
      headerName: "Vigencia hasta",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_vigencia_hasta;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "fecha_ultima_compra",
      headerName: "Última Compra",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_ultima_compra;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <>
            {params.row.habilitado && params.row.updatable && _editarDescuento && (
              <Tooltip title="editar">
                <IconButton
                  size="small"
                  aria-label="update"
                  onClick={() =>
                    handleClickActionCrud(params.row, "update")
                  }
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}

            {params.row.habilitado && params.row.updatable && _deshabilitarDescuento && (
              <Tooltip title="deshabilitar">
                <IconButton
                  size="small"
                  aria-label="disable"
                  onClick={() =>
                    handleClickActionCrud(params.row, "disable")
                  }
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            )}

            {!params.row.habilitado && params.row.updatable && _habilitarDescuento && (
              <Tooltip title="habilitar">
                <IconButton
                  size="small"
                  aria-label="enable"
                  onClick={() =>
                    handleClickActionCrud(params.row, "enable")
                  }
                >
                  <AddCircleOutlineOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadCristalProductos();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const loadCristalProductos = async () => {
    const response = await getCacheData("cristal_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCristalProductos(_var);
    } else {
      setCristalProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setValueACCristalProducto({ label: "", id: "" });
    setSearchData(initialSearchData);
    setItemsCrud([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      tipoArticulo: "cristal",
      idCristalProducto: searchData.idCristalProducto,
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getDescuentosCristal(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (parRow, action) => {
    let _itemCrud = {};

    if (action !== "new") {
      const loadItem = async () => {
        setIsDoingSomething(true);
        const response = await getDescuentoCristal({ id: parRow.id });
        setIsDoingSomething(false);

        if (response.ok) {
          _itemCrud = {
            id: response.data.data.id,
            cristalProducto: {
              id: response.data.data.id_cristal_producto,
              label: response.data.data.descripcion_cristal_producto,
            },
            porcentajeDescuento: response.data.data.porcentaje_descuento,
            fechaVigenciaDesde: response.data.data.fecha_vigencia_desde ? parse(response.data.data.fecha_vigencia_desde, 'dd/MM/yyyy', new Date()) : null,
            fechaVigenciaHasta: response.data.data.fecha_vigencia_hasta ? parse(response.data.data.fecha_vigencia_hasta, 'dd/MM/yyyy', new Date()) : null,
            fechaUltimaCompra: response.data.data.fecha_ultima_compra ? parse(response.data.data.fecha_ultima_compra, 'dd/MM/yyyy', new Date()) : null,
            observaciones: response.data.data.observaciones,
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setOpenDialog(true);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialog(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogSave = () => {
    load();
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="cristalProductos"
                  size="small"
                  value={valueACCristalProducto}
                  onChange={(event, newValue) => {
                    setValueACCristalProducto(newValue);
                    setSearchData({
                      ...searchData,
                      idCristalProducto: newValue === null ? "" : newValue.id,
                    });
                  }}
                  inputValue={inputValueACCristalProducto}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACCristalProducto(newInputValue);
                  }}
                  options={cristalProductos}
                  renderInput={(params) => (
                    <TextField {...params} label="Producto" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-documento-select-label">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearDescuento && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo descuento">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros de búsqueda">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>

          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openDialog && (
        <DescuentoCristalProductoDialog
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default DescuentoCristalProductoTable;
